<template>
  <div class="user-conter">
    <div class="user-contern-top w-1200">
      <div class="user-contern-top-left">
        <div class="avatar-user" v-if="userInfo">
          <img class="avatar" :src="userInfo.avatar">
          <img v-if="userInfo.vip_status == 1" class="user-vip" src="../../static/vip/VipVip.png" alt="vip">
          <img @click="goVip" v-else class="user-vip hit-cursor" src="../../static/vip/fy_ic_vip.png" alt="vip">
        </div>
        <div class="avatar-user-info">
          <div class="user-name" v-if="userInfo.realname">
            {{ userInfo.realname }}
          </div>
          <el-button type="text" v-else @click="goBaseInfo" class="goNext">点击填写用户名</el-button>
        </div>
      </div>
      <!-- 公司信息 -->
      <div class="user-contern-top-conter-box">
        <div class="user-contern-top-conter">
          <div class="company">
            审核状态:
            <span @click.stop="goBaseInfo">
              <el-tag type="success" v-if="userInfo.is_check == 1">审核通过</el-tag>
              <el-tag v-if="userInfo.is_check == -1" type="danger">审核失败 : {{ userInfo.remarks }}</el-tag>
              <el-tag type="warning" v-if="userInfo.is_check == 0">审核中</el-tag>
              <el-tag type="warning" v-if="userInfo.is_check == 2">请完善资料，提交审核</el-tag>
            </span>
          </div>
          <div class="company">
            企业名称: <span class="bold" v-if="userInfo.company">{{ userInfo.company }}</span> <span
              class="color-blue hit-cursor" v-else @click="goBaseInfo">去填写</span>
          </div>
          <div class="company">
            所在地区: <span v-if="userInfo.province">{{ userInfo.province }}{{ userInfo.city }}
              {{ userInfo.area }}</span> <span v-else class="color-blue hit-cursor" @click="goBaseInfo">去填写</span>
          </div>
          <div class="company">
            企业身份:<span v-if="userInfo.is_check != 2">{{ userInfo.role == 1 ? "贸易商" : "工厂" }}</span><span v-else
                                                                                                                  class="color-blue hit-cursor"
                                                                                                                  @click="goBaseInfo">去填写</span>
          </div>
          <div class="company">
            同事数量:
            <span class="bold"> {{ userInfo.user_count || "--" }} 人</span>
            <el-popover placement="top" width="160" trigger="hover">
              <div v-for="(item,index) in userInfo.tongshi" :key="index">
                <div style="margin: 6px">
                  <span>{{ item.realname }},</span>
                  <span>{{ item.company }}</span>
                </div>
              </div>
              <img slot="reference" src="@/static/user/wenhao.png"/>
            </el-popover>
          </div>
        </div>
      </div>
      <div class="user-contern-top-right">
        <div class="item-icon-box" @click="handlePost">
          <img src="@/static/user/post.png" alt=""/>
          <div>我的询单</div>
        </div>
        <div class="item-icon-box" @click="handleProduct">
          <img src="@/static/user/project.png" alt=""/>
          <div>我的产品</div>
        </div>
        <div class="item-icon-box" @click="handleQuote">
          <img src="@/static/user/price.png" alt=""/>
          <div>我的报价</div>
        </div>
      </div>
    </div>
    <!-- VIP升级通知 -->
    <PrivateInner></PrivateInner>
    <!-- 用户统计卡片 -->
    <div class="w-1200 user-stats-section">
      <div class="user-stats-card">
        <div class="user-stats-row">
          <div class="user-stats-item hit-cursor" @click="handleProduct">
            <div class="stats-icon product-icon">
              <i class="el-icon-goods"></i>
            </div>
            <div class="stats-content">
              <div class="stats-value">{{ user_count.product_count }}</div>
              <div class="stats-label">已发布产品</div>
            </div>
          </div>
          <div class="user-stats-item hit-cursor" @click="handleQuote">
            <div class="stats-icon quote-icon">
              <i class="el-icon-s-order"></i>
            </div>
            <div class="stats-content">
              <div class="stats-value">{{ user_count.quote_count }}</div>
              <div class="stats-label">收到询单</div>
            </div>
          </div>
          <div class="user-stats-item hit-cursor" @click="handleOrder">
            <div class="stats-icon order-icon">
              <i class="el-icon-shopping-cart-2"></i>
            </div>
            <div class="stats-content">
              <div class="stats-value">{{ user_count.quote_success_count }}</div>
              <div class="stats-label">收到报价</div>
            </div>
          </div>
          <div class="user-stats-item" @click="handleSuccess">
            <div class="stats-icon revenue-icon">
              <i class="el-icon-money"></i>
            </div>
            <div class="stats-content">
              <div class="stats-value">{{ user_count.total_price }}</div>
              <div class="stats-label">累计成交金额(元)</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-1200 title">采购到期</div>
    <div class="user-contern-body w-1200">
      <div class="teble" v-loading="loading">
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" border
                  :header-cell-style="{ backgroundColor: '#F6F6F8' }">
          <el-table-column fixed type="index" label="序号" width="55">
          </el-table-column>
          <el-table-column prop="cas_no" label="CAS号"/>
          <el-table-column prop="product_name" label="产品名称"/>
          <el-table-column prop="product_name" label="需求数量">
            <template slot-scope="scope">
              {{ scope.row.number }} {{ scope.row.unit }}
            </template>
          </el-table-column>
          <el-table-column prop="begin_at" label="发布时间"></el-table-column>
          <el-table-column prop="end_at" label="到期时间"></el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == '1'" type="success">进行中0人已报价</el-tag>
              <el-tag v-else-if="scope.row.status == '2'" type="success">进行中 {{
                  scope.row.quote_count
                }}人已报价
              </el-tag>
              <el-tag v-else-if="scope.row.status == '-1'||scope.row.status == '3'" type="info">已结束</el-tag>
              <el-tag v-else-if="scope.row.status == '-2'" type="danger">已到期</el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="210">
            <template slot-scope="scope">
              <div class="operation">
                <el-button @click="lookDetail(scope.row)" type="text" size="small">查看</el-button>
                <el-button type="text" size="small" @click="handleRelease(scope.row)">再次报价</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-box">
        <el-pagination class="float-right" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="page" :page-sizes="[10, 50, 100, 200]" :page-size="limit" background
                       layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 采购订单详情 -->
    <OrderLook :detailVisible="detailVisible" :dataInfo="lookData" @updateStatus="updateStatus"></OrderLook>
  </div>
</template>
<script>
import {
  expire_purchase,
  purchaseDetail,
  quote_list_api,
} from "@/api/modules/user";
import OrderLook from "@/components/orderLook/orderLook.vue";
import PrivateInner from "@/components/Title/private-inner.vue";

export default {
  name: "user-center",
  components: {PrivateInner, OrderLook},

  data() {
    return {
      loading: false,
      total: 0,
      page: 1,
      limit: 10,
      lookData: {},
      detailVisible: false,
      cas_no_quoteList: [],
      tableData: [],
      quoteVisible: false,
      quoteForm: {},
      // 统计信息
      numberInfo: {},

    };
  },
  computed: {
    user_count() {
      return this.$store.getters.user_count;
    },
    is_vip() {
      return this.$store.getters.is_vip;
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    is_check() {
      return this.$store.getters.is_check;
    },
    is_login() {
      return this.$store.getters.is_login;
    },
  },
  mounted() {
    this.$store.dispatch('GET_USER_INFO');
    this.$store.dispatch('GET_USER_COUNT');
    this.getExpirePurchase();
  },

  methods: {
    updateStatus(e) {
      this.detailVisible = e
    },
    goBaseInfo() {
      this.$router.push("/user/base-info");
    },
    handleOrder() {
      this.$router.push("/user/purchase/post");
    },
    handleSuccess() {
      this.$router.push("/user/purchase/order");
    },

    // 编辑
    handleRelease(row) {
      this.$router.push({
        path: "/user/purchase/release",
        query: {id: row.id},
      });

    },
    // 立即购买
    handleBay(row) {
      this.quoteVisible = true;
      this.quoteForm = row;
      this.$router.push({
        path: "/user/purchase/bay",
        query: {id: row.id},
      });
    },
    // 查看详情
    lookDetail(row) {
      this.lookData = row
      this.detailVisible = true
    },
    // 获取采购到期
    getExpirePurchase() {
      this.loading = true;
      expire_purchase({
        page: this.page,
        limit: this.limit,
      }).then((res) => {
        this.tableData = res.data.data.data;
        this.total = res.data.data.total;
        this.loading = false;
      });
    },
    // 我的发布
    handlePost() {
      this.$router.push("/user/purchase/post");
    },
    // 我的产品
    handleProduct() {
      this.$router.push("/user/supplier/my-project");
    },
    // 我的报价
    handleQuote() {
      this.$router.push("/user/supplier/quotation");
    },
    handleSizeChange(val) {
      this.limit = val;
      this.getExpirePurchase();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getExpirePurchase();
    },
    detailClose() {
      this.detailVisible = false;
    },
    // 跳转到VIP页面
    goVip() {
      this.$router.push({path: '/vip/vip'});
    },
  },
};
</script>
<style lang="scss" scoped>
.color-blue {
  color: #0c60e6;
}

.user-vip {
  position: absolute;
  top: 80px;
  left: 10px;
  width: 30px;
  height: 30px;
}

.user-breadcrumb {
  margin-bottom: 20px;
}

.user-number {
  .user-desc {
    font-size: 18px;
    color: #333;
    margin: 12px 0;
    line-height: 2;
    letter-spacing: 0.5px;
  }

  .bold {
    color: #409eff;
    font-size: 22px;
    font-weight: bold;
    margin: 0 4px;
  }
}

.user-conter {
  padding-bottom: 100px;

  .user-contern-top {
    box-sizing: border-box;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    padding: 20px 40px;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 16px 48px rgba(64, 158, 255, 0.15);
    }

    .user-contern-top-left {
      display: flex;
      align-items: center;
      position: relative;

      // width: 500px;
      .avatar-user {
        width: 100px;
        height: 100px;
        //background: #F5F5F5;
        margin-right: 20px;
        border-radius: 50%;
        position: relative;

        .avatar {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .avatar-user-info {
        .user-name {
          font-weight: bold;
          font-size: 28px;
          color: #00112b;
        }

        .goNext {
          font-size: 16px;
          color: #0c60e6;
        }

        .user-www {
          font-weight: 500;
          font-size: 20px;
          color: #0c60e6;
        }
      }
    }

    .user-contern-top-conter-box {
      display: flex;
      align-items: center;
      // width: 100%;
    }

    .user-contern-top-conter {
      width: 100%;
      font-weight: 500;
      //font-size: 18px;
      color: #5f616c;
      line-height: 25px;
      // padding: 20px 0 0 65px;
      flex: 1;

      .company {
        margin-bottom: 13px;

        &:last-child {
          margin-bottom: 0;
        }

        img {
          width: 16px;
          height: 16px;
          margin-left: 5px;
        }
      }
    }

    .user-contern-top-right {
      // width: 559px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      border-left: 1px solid #e5e5e5;

      .item-icon-box {
        width: 150px;
        height: 100px;
        font-weight: bold;
        font-weight: bold;
        font-size: 20px;
        color: #00112b;
        text-align: center;

        img {
          width: 60px;
          height: 60px;
        }
      }
    }
  }

  .user-contern-body {
    box-sizing: border-box;

    background: #ffffff;
    border-radius: 4px;
  }

  .title {
    font-weight: 800;
    font-size: 20px;
    color: #00112b;
    padding-bottom: 20px;
  }

  .teble {
    position: relative;
    z-index: 10;
    padding: 20px;

    .operation {
      display: flex;
      justify-content: space-around;
      align-items: center;

      .el-button {
        font-weight: 500;
        font-size: 16px;
      }
    }
  }
}

.pagination-box {
  text-align: right;
  padding-bottom: 20px;
  padding-right: 20px;
}

.user-stats-card {
  background: #ffffff;
  // border-radius: 8px;
  box-shadow: 0 4px 24px rgba(64, 158, 255, 0.08),
  0 1.5px 6px rgba(0, 0, 0, 0.04);
  padding: 32px 24px;
  margin: 32px 0;
  transition: box-shadow 0.2s;
}

.user-stats-card:hover {
  box-shadow: 0 8px 32px rgba(64, 158, 255, 0.16),
  0 3px 12px rgba(0, 0, 0, 0.08);
}

.user-stats-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
}

.user-stats-item {
  flex: 1;
  text-align: center;
  padding: 16px 0;
  border-right: 1px solid #e6e8eb;
  transition: background 0.2s;
}

.user-stats-item:last-child {
  border-right: none;
}

.stats-label {
  font-size: 15px;
  color: #7a8599;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}

.stats-value {
  font-size: 36px;
  font-weight: 700;
  color: #409eff;
  background: linear-gradient(90deg, #409eff 30%, #66b1ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 1px;
  margin-top: 4px;
  text-shadow: 0 2px 8px rgba(64, 158, 255, 0.08);
  transition: color 0.2s;
}

@media (max-width: 900px) {
  .user-stats-row {
    flex-direction: column;
    gap: 16px;
  }

  .user-stats-item {
    border-right: none;
    border-bottom: 1px solid #e6e8eb;
  }

  .user-stats-item:last-child {
    border-bottom: none;
  }
}

.audit-status-full-card {
  width: 100%;
  min-height: 180px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(53, 53, 53, 0.08);
  margin-bottom: 18px;
  position: relative;
  padding: 0 20px;
}

.audit-status-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.audit-status-full-card i {
  font-size: 30px;
  margin-bottom: 18px;
}

/* VIP通知样式 */

.vip-notice-content {
  margin: 30px 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px 32px;
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
  border: 2px solid #ffcc02;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(255, 204, 2, 0.2);
  position: relative;
  overflow: hidden;
  animation: vipPulse 3s ease-in-out infinite;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
    animation: vipShine 4s ease-in-out infinite;
  }

  .vip-notice-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    i {
      font-size: 32px;
      color: #f57c00;
      animation: vipIconBounce 2s ease-in-out infinite;
    }

    .vip-text {
      .vip-title {
        font-size: 18px;
        font-weight: 700;
        color: #e65100;
        margin-bottom: 4px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
      }

      .vip-subtitle {
        font-size: 14px;
        color: #f57c00;
        opacity: 0.8;
      }
    }
  }

  .vip-upgrade-btn {
    background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
    border: none;
    color: white;
    font-weight: 600;
    padding: 12px 24px;
    border-radius: 10px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(255, 152, 0, 0.3);
    display: flex;
    align-items: center;
    gap: 8px;
    z-index: 1;
    position: relative;

    i {
      font-size: 16px;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(255, 152, 0, 0.5);
      background: linear-gradient(135deg, #f57c00 0%, #e65100 100%);
    }

    &:active {
      transform: translateY(0);
    }
  }


  @keyframes vipPulse {

    0%,
    100% {
      transform: scale(1);
      box-shadow: 0 8px 32px rgba(255, 204, 2, 0.2);
    }

    50% {
      transform: scale(1.01);
      box-shadow: 0 12px 40px rgba(255, 204, 2, 0.3);
    }
  }

  @keyframes vipShine {
    0% {
      left: -100%;
    }

    50% {
      left: 100%;
    }

    100% {
      left: 100%;
    }
  }

  @keyframes vipIconBounce {

    0%,
    100% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(-4px);
    }
  }
}

/* 用户统计卡片样式 */
.user-stats-section {
  .user-stats-card {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    box-shadow: 0 8px 32px rgba(64, 158, 255, 0.1);
    padding: 40px 32px;
    margin: 32px 0;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 16px 48px rgba(64, 158, 255, 0.15);
    }

    .user-stats-row {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 24px;
      align-items: center;
    }

    .user-stats-item {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 24px;
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      border-radius: 16px;
      border: 1px solid #e9ecef;
      transition: all 0.3s ease;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(135deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.05) 100%);
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(64, 158, 255, 0.15);
        border-color: #409eff;

        &::before {
          opacity: 1;
        }

        .stats-icon {
          transform: scale(1.1);
        }

        .stats-value {
          transform: scale(1.05);
        }
      }

      .stats-icon {
        width: 60px;
        height: 60px;
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        color: white;
        transition: all 0.3s ease;
        position: relative;
        z-index: 1;

        &.product-icon {
          background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
          box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
        }

        &.quote-icon {
          background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
          box-shadow: 0 4px 12px rgba(103, 194, 58, 0.3);
        }

        &.order-icon {
          background: linear-gradient(135deg, #e6a23c 0%, #ebb563 100%);
          box-shadow: 0 4px 12px rgba(230, 162, 60, 0.3);
        }

        &.revenue-icon {
          background: linear-gradient(135deg, #f56c6c 0%, #f78989 100%);
          box-shadow: 0 4px 12px rgba(245, 108, 108, 0.3);
        }
      }

      .stats-content {
        flex: 1;
        text-align: left;
        position: relative;
        z-index: 1;

        .stats-value {
          font-size: 32px;
          font-weight: 700;
          color: #00112b;
          margin-bottom: 8px;
          transition: all 0.3s ease;
          line-height: 1;
        }

        .stats-label {
          font-size: 14px;
          color: #7a8599;
          font-weight: 500;
          letter-spacing: 0.5px;
        }
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .vip-notice-section {
    .vip-notice {
      .vip-notice-content {
        flex-direction: column;
        gap: 16px;
        text-align: center;

        .vip-notice-left {
          flex-direction: column;
          gap: 12px;
        }
      }
    }
  }

  .user-stats-section {
    .user-stats-card {
      .user-stats-row {
        grid-template-columns: 1fr;
        gap: 16px;
      }

      .user-stats-item {
        padding: 20px;

        .stats-icon {
          width: 50px;
          height: 50px;
          font-size: 20px;
        }

        .stats-content {
          .stats-value {
            font-size: 28px;
          }
        }
      }
    }
  }
}

.audit-status-text {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 18px;
  color: #646464;
  text-align: center;
}

.audit-btn-large {
  font-size: 16px;
  padding: 8px 32px;
  border-radius: 8px;
  margin-top: 8px;
}

.audit-status-full-card.warning {
  background: #fffbe6;
}

.audit-status-full-card.error {
  background: #fff1f0;
}

.audit-status-full-card.info {
  background: #e6f7ff;
  color: #0c60e6 !important;
}

// 响应式设计 - 添加以下媒体查询
@media (max-width: 1200px) {
  .user-contern-top {
    flex-direction: column;
    height: auto;
    padding: 20px;

    .user-contern-top-left {
      width: 100%;
      justify-content: center;
      margin-bottom: 20px;
      position: relative;

      .avatar-user {
        width: 80px;
        height: 80px;
      }

      .user-vip {
        bottom: 10px;
        left: 55px;
        width: 24px;
        height: 24px;
      }

      .avatar-user-info {
        .user-name {
          font-size: 24px;
        }
      }
    }

    .user-contern-top-conter-box {
      width: 100%;
      margin-bottom: 20px;
    }

    .user-contern-top-conter {
      padding: 0;

      .company {
        font-size: 14px;
        margin-bottom: 10px;

        .bold {
          font-size: 16px;
        }
      }
    }

    .user-contern-top-right {
      width: 100%;
      border-left: none;
      padding-top: 20px;

      .item-icon-box {
        width: auto;
        height: auto;
        font-size: 16px;

        img {
          width: 40px;
          height: 40px;
        }
      }
    }
  }

  .user-stats-row {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .user-contern-top {
    .user-contern-top-left {
      flex-direction: column;
      text-align: center;

      .avatar-user {
        margin-right: 0;
        margin-bottom: 10px;
      }

      .avatar-user-info {
        .user-name {
          font-size: 20px;
        }
      }
    }

    .user-contern-top-conter {
      .company {
        font-size: 13px;
        margin-bottom: 8px;
      }
    }

    .user-contern-top-right {
      flex-wrap: wrap;

      .item-icon-box {
        width: 33%;
        font-size: 14px;
        margin-bottom: 10px;
      }
    }
  }

  .user-stats-row {
    grid-template-columns: 1fr;
    gap: 12px;

    .user-stats-item {
      padding: 16px;

      .stats-icon {
        width: 48px;
        height: 48px;
        font-size: 20px;
      }

      .stats-content {
        .stats-value {
          font-size: 24px;
        }

        .stats-label {
          font-size: 12px;
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .user-contern-top {
    padding: 15px;

    .user-contern-top-left {
      .avatar-user {
        width: 70px;
        height: 70px;
      }

      .user-vip {
        bottom: 5px;
        left: 50px;
        width: 20px;
        height: 20px;
      }

      .avatar-user-info {
        .user-name {
          font-size: 18px;
        }

        .goNext {
          font-size: 14px;
        }
      }
    }

    .user-contern-top-conter {
      .company {
        font-size: 12px;
        margin-bottom: 6px;
      }
    }

    .user-contern-top-right {
      .item-icon-box {
        width: 50%;
        font-size: 12px;
        padding: 5px 0;

        img {
          width: 30px;
          height: 30px;
        }
      }
    }
  }

  .user-stats-card {
    padding: 20px 15px;
    margin: 20px 0;
  }

  .user-stats-row {
    gap: 10px;

    .user-stats-item {
      padding: 12px;

      .stats-icon {
        width: 40px;
        height: 40px;
        font-size: 16px;
      }

      .stats-content {
        .stats-value {
          font-size: 20px;
        }

        .stats-label {
          font-size: 11px;
        }
      }
    }
  }

  .title {
    font-size: 18px;
    padding-bottom: 15px;
  }

  ::v-deep .el-table th,
  ::v-deep .el-table td {
    padding: 8px 0;
    font-size: 12px;
  }

  ::v-deep .el-pagination {
    font-size: 12px;

    .btn-prev,
    .btn-next,
    .el-pager li {
      min-width: 26px;
      height: 26px;
      line-height: 26px;
    }
  }
}

// 针对超小屏幕的优化
@media (max-width: 360px) {
  .user-contern-top {
    .user-contern-top-conter {
      .company {
        font-size: 11px;
      }
    }

    .user-contern-top-right {
      .item-icon-box {
        font-size: 11px;
      }
    }
  }

  .user-stats-row {
    .user-stats-item {
      .stats-content {
        .stats-value {
          font-size: 18px;
        }
      }
    }
  }

  ::v-deep .el-dialog {
    width: 95% !important;
    margin-top: 20px !important;
  }


}
</style>
